export const ReviseMeta = (title, keywords, description) => {
  // 修改 <title> 标签内容
  if (title) {
    document.title = title
  }

  if (keywords) {
    document.querySelector('meta[name="keywords"]')?.setAttribute('content', keywords)
  }
  if (description) {
    document.querySelector('meta[name="description"]')?.setAttribute('content', description)
  }
}

export const shareMeta = (url, title, image, description) => {
  if (title) {
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', title)
  }
  if (url) {
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', url)
  }
  if (image) {
    document.querySelector('meta[property="og:image"]')?.setAttribute('content', image)
  }
  if (description) {
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', description)
  }
}

export const shareTwitterMeta = (title, image, description) => {
  if (title) {
    document.querySelector('meta[name="twitter:title"]')?.setAttribute('content', title)
  }
  if (image) {
    document.querySelector('meta[name="twitter:image"]')?.setAttribute('content', image)
  }
  if (description) {
    document.querySelector('meta[name="twitter:description"]')?.setAttribute('content', description)
  }
}
